import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';
import { Category } from '../types';

const getGameCategories = (
  categoryIds: string
): Promise<{ categories: Category[] }> =>
  api.get(`/game-categories`, {
    params: {
      categoryIds,
    },
  });

export const useGetGameCategoriesMutation = () => {
  return useMutation({
    mutationFn: getGameCategories,
    onSuccess: () => {},
    onError: () => {},
  });
};
